"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectPositionFromClass = exports.toObject = exports.isFabricOnlyObject = exports.isFabricWidgetObject = void 0;
var fabric_1 = require("fabric");
var Widgets_1 = require("./Widgets");
var Objects_1 = require("./Objects");
/**
 * toObject util
 * @param {*} obj
 * @param {string[]} propertiesToInclude
 */
var toObject = function (obj, propertiesToInclude) {
    return fabric_1.fabric.util.object.extend(obj.callSuper('toObject'), propertiesToInclude.reduce(function (prev, property) {
        var _a;
        return Object.assign(prev, (_a = {},
            _a[property] = obj.get(property),
            _a));
    }, {}));
};
exports.toObject = toObject;
var getObjectPositionFromClass = function (thisFromClass) {
    var _a, _b;
    var coords = thisFromClass.calcACoords();
    if (coords) {
        var left = (_a = coords.tl) === null || _a === void 0 ? void 0 : _a.x;
        var top_1 = (_b = coords.tl) === null || _b === void 0 ? void 0 : _b.y;
        return {
            left: left,
            top: top_1
        };
    }
    return {
        left: 0,
        top: 0
    };
};
exports.getObjectPositionFromClass = getObjectPositionFromClass;
var isFabricWidgetObject = function (obj) {
    return (0, Widgets_1.isFabricDateObject)(obj) ||
        (0, Widgets_1.isFabricIframeObject)(obj) ||
        (0, Widgets_1.isFabricMediaCarouselObject)(obj) ||
        (0, Widgets_1.isFabricQRCodeObject)(obj) ||
        (0, Widgets_1.isFabricRssFeedObject)(obj) ||
        (0, Widgets_1.isFabricStopScheduleObject)(obj) ||
        (0, Widgets_1.isFabricSocialMediaObject)(obj) ||
        (0, Widgets_1.isFabricTableObject)(obj) ||
        (0, Widgets_1.isFabricVideoObject)(obj) ||
        (0, Widgets_1.isFabricWeatherObject)(obj) ||
        (0, Widgets_1.isFabricFalconyAnnouncementsObject)(obj);
};
exports.isFabricWidgetObject = isFabricWidgetObject;
var isFabricOnlyObject = function (obj) {
    return (0, Objects_1.isFabricCircleObject)(obj) ||
        (0, Objects_1.isFabricImageObject)(obj) ||
        (0, Objects_1.isFabricLineObject)(obj) ||
        (0, Objects_1.isFabricPathObject)(obj) ||
        (0, Objects_1.isFabricPolygonObject)(obj) ||
        (0, Objects_1.isFabricRectObject)(obj) ||
        (0, Objects_1.isFabricTextboxObject)(obj) ||
        (0, Objects_1.isFabricTriangleObject)(obj);
};
exports.isFabricOnlyObject = isFabricOnlyObject;
//# sourceMappingURL=fabricObjectUtils.js.map